export default __webpack_public_path__ + "static/media/Thumb_vimpel.77dee273.png";